export default "__VITE_ASSET__CnUgQ1hR__"